import { useLezsQuery } from "@evr/apis/lez";
import { useAppSelector } from "@evr/hooks/reduxHooks";
import { selectLezsQuery } from "@evr/store/slices/lez";

export const useGetLezsQuery = () => {
  const queryParams = useAppSelector(selectLezsQuery);
  return useLezsQuery(queryParams);
};
